import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-hot-toast";
import { CREATE_SHIPMENT_API,GET_SHIPMENT_API,SUBMIT_SHIPMENT_API, UPLOAD_SHIPMENT_API } from "src/config/apiConfig";
import { PriceRequest, SubmitRequest } from "src/models/master_data/price/price.dto";

export const fetchMsShipmentThunk = createAsyncThunk(
    'msShipment/fetchMsShipmentThunk',
    async (
        {
            pageNumber,
            pageSize,
            sortBy = 'Id', 
            sortOrder = 'asc',
            query = ''
        }: {
            pageNumber: number;
            pageSize: number;
            sortBy?: string;
            sortOrder?: string;
            query?: string
        },
        thunkAPI) => {
        try {
            const accessToken = localStorage.getItem('userToken');
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

             // Transform sortBy to camelCase where the first letter is uppercase
             const formattedSortBy = sortBy.charAt(0).toUpperCase() + sortBy.slice(1);

            const response = await axios.get(`${GET_SHIPMENT_API}`, {
                params: {
                    PageNumber: pageNumber,
                    PageSize: pageSize,
                    SortBy: formattedSortBy,
                    SortOrder: sortOrder,
                    Query: query
                },
                headers: {
                    ...headers,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                toast.error('Failed to fetch documents');
                return thunkAPI.rejectWithValue('Failed to fetch documents');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.message || 'An error occurred while fetching documents');
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const createMsShipmentThunk = createAsyncThunk(
    'msShipment/createMsShipmentThunk',
    async (priceData: PriceRequest, thunkAPI) => {
        try {
            const response = await axios.post(CREATE_SHIPMENT_API, priceData);
            if (response.status === 200 || response.status === 201) {
                toast.success('Shipment created successfully');
                return { data: response.data };
            } else {
                toast.error('Failed to create shipment');
                return thunkAPI.rejectWithValue('Failed to create shipment');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while creating the shipment');
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const uploadMsShipmentThunk = createAsyncThunk(
    'msShipment/uploadMsShipmentThunk',
    async (file: File, thunkAPI) => {
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axios.post(UPLOAD_SHIPMENT_API, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.status === 200) {
                toast.success('File uploaded successfully');
                return { data: response.data };
            } else {
                toast.error('Failed to upload file');
                return thunkAPI.rejectWithValue('Failed to upload file');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while uploading the file');
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const submitMsShipmentThunk = createAsyncThunk(
    'msShipment/submitMsShipmentThunk',
    async (submitData: SubmitRequest, thunkAPI) => {
        try {
            const response = await axios.post(SUBMIT_SHIPMENT_API, submitData);
            if (response.status === 200) {
                toast.success('Shipment submitted successfully');
                return { data: response.data };
            } else {
                toast.error('Failed to submit shipment');
                return thunkAPI.rejectWithValue('Failed to submit shipment');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while submitting shipment');
            return thunkAPI.rejectWithValue(error);
        }
    }
);